/* =========================================================================
   COMPONENT: ATELIER CARD (Simple Modal Trigger)
   ========================================================================= */
window.AtelierCardUI = (function() {

  function init() {
    document.addEventListener('click', function(e) {
      
      // Ensure we are clicking inside a card wrapper
      var wrap = e.target.closest('.atelier-card-wrap') || e.target.closest('.atelier-card');
      if (!wrap) return;

      // 1. Explicit Modal Triggers on the Card
      var learnTrigger = e.target.closest('.js-panel-learn');
      var originTrigger = e.target.closest('.js-panel-origin');
      var ingrTrigger = e.target.closest('.js-panel-ingr');

      if (learnTrigger || originTrigger || ingrTrigger) {
        var view = 'learn';
        if (originTrigger) view = 'origin';
        if (ingrTrigger) view = 'ingr';
        
        if (window.AtelierModalUI) {
          window.AtelierModalUI.openModal(wrap, view);
        }
        return;
      }

      // 2. Catch-All: Clicking anywhere else on the card opens 'About'
      // Guardrail: Do not fire if they clicked the qty-widget or an external link
      var isInteractive = e.target.closest('.atelier-qty-widget') || e.target.closest('a');
      
      if (!isInteractive) {
        if (window.AtelierModalUI) {
          window.AtelierModalUI.openModal(wrap, 'learn');
        }
      }
      
    });
  }

  return { init };
})();

if (document.readyState === 'loading') { 
  document.addEventListener('DOMContentLoaded', window.AtelierCardUI.init); 
} else { 
  window.AtelierCardUI.init(); 
}